import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller<HTMLInputElement> {
    connect() {
        const im = new Inputmask("email");
        im.mask(this.element)
    }
}
